import React, { FC } from 'react';
import { SvgIcon as MuiSvgIcon, Theme, styled, useTheme } from '@material-ui/core';
import Icons from './Icons';

export type SvgIconProps = {
  icon: Icons;
  color?: string;
  large?: boolean;
  small?: boolean;
  viewBox?: string;
  style?: React.CSSProperties;
  ref?: React.Ref<any>;
};

const StyledSvgIcon = styled(MuiSvgIcon)({
  width: '1.8rem !important',
  height: '1.8rem !important',
  '&.large': {
    width: '2.2rem !important',
    height: '2.2rem !important',
  },
  '&.small': {
    width: '1.4rem !important',
    height: '1.4rem !important',
  },
});

const SvgIcon: FC<SvgIconProps> = ({ icon, color, viewBox, large, small, ...other }) => {
  const theme: Theme = useTheme();
  const iconColor = color || theme.palette.primary.main;

  return (
    <StyledSvgIcon
      viewBox={viewBox ?? '0 0 24 24'}
      className={large ? 'large' : small ? 'small' : undefined}
      {...other}
    >
      <path style={{ fill: iconColor }} d={icon} />
    </StyledSvgIcon>
  );
};

export default SvgIcon;
